module.exports = __webpack_public_path__ + "static/about-insta-1-3f0652278a8e46073a4127b790891459.jpg";